import React from "react"

export default function Input({
  type = "text",
  className = "",
  placeholder = "",
  value,
  onChange,
  disabled = false,
  ...rest
}) {
  const baseClass = `
    flex h-10 w-full border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm
  `

  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`${baseClass} ${className}`}
      {...rest}
    />
  )
}
